var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApEvacAlertSystemIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.221,0H17.486A3.239,3.239,0,0,0,14,2.9V21.484a3.239,3.239,0,0,0,3.486,2.9h2.9a8.086,8.086,0,0,1,.584,2.956V28.75a3.778,3.778,0,0,0,1.43,2.875l.1.087A1.659,1.659,0,0,0,21.67,33.1V36H35.616V33.1a1.661,1.661,0,0,0-.837-1.385l.1-.087a3.732,3.732,0,0,0,1.429-2.874V23.8a2.784,2.784,0,0,0,1.395-2.32V2.9A3.239,3.239,0,0,0,34.221,0ZM15.395,21.484V2.9a1.8,1.8,0,0,1,1.395-1.635v21.85A1.794,1.794,0,0,1,15.395,21.484Zm4.184.939a1.329,1.329,0,0,0,.192.68c.024.039.04.082.063.123h-1.65V1.161h15.34V20.429a2.314,2.314,0,0,0-.328.126,2.209,2.209,0,0,0-1.763-.813,2.394,2.394,0,0,0-1.026.233,2.209,2.209,0,0,0-1.763-.813,2.441,2.441,0,0,0-.7.107V18.177a4.085,4.085,0,0,0,2.789-3.661c0-2.241-2.189-4.065-4.881-4.065s-4.881,1.824-4.881,4.065a4.085,4.085,0,0,0,2.789,3.661v3.44A4.188,4.188,0,0,0,21.4,20.9,1.7,1.7,0,0,0,19.578,22.423Zm4.184-6.746v1.16a2.778,2.778,0,0,1-1.395-2.321,3.239,3.239,0,0,1,3.486-2.9,3.239,3.239,0,0,1,3.486,2.9,2.778,2.778,0,0,1-1.395,2.321v-1.16a1.944,1.944,0,0,0-2.092-1.742A1.944,1.944,0,0,0,23.762,15.677ZM34.221,34.839H23.065V33.1a.648.648,0,0,1,.7-.581h9.762a.648.648,0,0,1,.7.581Zm.7-6.088A2.666,2.666,0,0,1,33.9,30.8l-.662.551H24.051l-.662-.551a2.7,2.7,0,0,1-1.022-2.054V27.343a9.271,9.271,0,0,0-1.349-4.759.312.312,0,0,1-.045-.161.4.4,0,0,1,.431-.359,2.191,2.191,0,0,1,2.358,1.964v1.52h1.395V15.677a.709.709,0,0,1,1.395,0v9.871h1.395V20.9a.709.709,0,0,1,1.395,0v4.645h1.395V21.484a.709.709,0,0,1,1.395,0v4.065h1.395V22.064a.709.709,0,0,1,1.395,0Zm1.395-7.267a1.384,1.384,0,0,1-.04.25,1.882,1.882,0,0,0-1.354-1.3V1.268A1.8,1.8,0,0,1,36.313,2.9Z",
    transform: "translate(-14)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.551,4H22v8.367H34.551Zm-1.395,6.973H23.395V5.395h9.762Z",
    transform: "translate(-16.422 -1.211)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 3,
    transform: "translate(8.293 5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 1,
    height: 3,
    transform: "translate(11.293 5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 3,
    transform: "translate(13.293 5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApEvacAlertSystemIcon);
export default __webpack_public_path__ + "static/media/ap-evac-alert-system-icon.74a7c824a02e8bf9ba74cf19d61af6c6.svg";
export { ForwardRef as ReactComponent };